<template>
  <div class="philosophy">
    <div class="content">
      <header>
        <span class="title">Philosophy</span>
        <h2>Always Delivering</h2>
      </header>
      <div class="detail">
       <p>We believe in delivering value early and often. During the discovery phase, we identify the most valuable set of outcomes. After carefully evaluating dependencies that exist between features sets, we create a strategic delivery plan aimed at continuously deploying usable software as quickly as possible. This enables those outcomes to be achieved in smaller phases along the way – beginning early on in the project lifecycle.</p>
      </div>
    </div>
    <div class="media">
      <img src="../../public/img/elovate_users_crop.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'philosophy',
}
</script>

<style lang="scss" scoped>
.philosophy {
  margin-top: 96px;
  display: flex;
      @media(max-width: 700px) {
        flex-direction: column;
      }
  .media {
    margin-left: 116px;
          @media(max-width: 700px) {
            margin-right: 0;
            margin-left: 86px;
            max-width: 100%;
            img {
              max-width: 100%;
            }
      }
  }

  .content {
    position: relative;
    .title {
      display: block;
      width: 100%;
      display: flex;
      color: rgba(0, 0, 0, 0.87);
      font-family: Archia;
      font-size: 12.19px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 16px;
      text-transform: uppercase;
      &:before {
        content: "";
        display: inline-block;
        height: 1px;
        width: 132px;
        background-color: rgba(#000, 0.87);
        position: relative;
        top: 6px;
        margin-right: 8px;
        opacity: 0.3;
        @media(max-width: 700px) {
          width: 64px;
        }
      }
    }
    .detail {
      padding-left: 140px;
      @media(max-width: 700px) {
        padding-left: 64px;
        padding-right: 16px;
      }
    }
  }
}

h2 {
  height: 24px;
  width: 471px;
  color: #1a222f;
  font-family: Archia;
  font-size: 20.32px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 24px;
  margin: 44px 0 16px 0;
  padding-left: 140px;
        @media(max-width: 700px) {
        padding-left: 64px;
        padding-right: 16px;
      }
}

p {
  color: #1a222f;
  font-family: Rubik;
  font-size: 16.26px;
  letter-spacing: 0.5px;
  line-height: 28px;
  opacity: .7;
}
</style>